<h2>
  <i class="fas fa-file-invoice"></i
  ><span class="header">Trial Accounts Requests</span>
</h2>
<app-trial-accounts-filters
  [filters]="trialAccountsRequestsFilters$ | async"
  (changeFilters)="loadTrialRequests($event)"
></app-trial-accounts-filters>
<app-trial-accounts-list
  [trialAccountsRequests]="trialAccountsRequests$ | async"
  [isLoading]="trialAccountsIsLoading$ | async"
  [hasTrialDispenserRole]="hasTrialDispenserRole$ | async"
  [selectedRequestId]="selectedRequest$ | async"
  (approve)="approve($event)"
  (decline)="decline($event)"
></app-trial-accounts-list>
